import styled from "styled-components";
import { colors } from "../../infrastructure/theme/colors.js";
import { fontWeights, fontSizes } from "../../infrastructure/theme/fonts";
import { Text } from "../typography/text.component.js";
// import { Loader } from "../loaders/loaders.component";

export const ButtonStyles = styled.button`
  cursor: pointer;
  width: ${({ width }) => (width ? width : "max-content")};
  min-width: max-content;
  background: ${({ background }) => (background ? background : colors.primary)};
  box-shadow: ${({ boxShadow }) =>
    boxShadow ? boxShadow : "0px 15px 50px rgba(222, 95, 143, 0.12)"};
  border: ${({ border }) => (border ? border : "0px")};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : "6px")};
  padding: ${({ paddingVertical }) =>
      paddingVertical ? paddingVertical : "0.9rem"}
    ${({ paddingHorizontal }) =>
      paddingHorizontal ? paddingHorizontal : "1rem"};
  color: ${({ btnColor }) => (btnColor ? btnColor : colors.white)};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const BtnText = styled(Text)`
  padding: 0 0.5rem;
  color: ${({ btnColor }) => (btnColor ? btnColor : colors.white)};
  text-transform: ${({ textTransform }) =>
    textTransform ? textTransform : "Uppercase"};
  font-weight: ${({ fontWeight }) =>
    fontWeight ? fontWeight : fontWeights.bold};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : fontSizes.h5)};
  font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : "Oswald")};

  @media (max-width: 800px) {
    font-size: ${({ resfontSize }) => (resfontSize ? resfontSize : fontSizes.h5)};
  }
`;

export const Button = ({
  btnText,
  background,
  border,
  borderRadius,
  boxShadow,
  btnColor,
  textTransform,
  fontWeight,
  fontSize,
  onClick,
  loading,
  RightIcon,
  LeftIcon,
  iconSize,
  paddingHorizontal,
  paddingVertical,
  disabled,
  width,
  fontFamily,
  resfontSize,
}) => {
  return (
    <ButtonStyles
      background={background}
      border={border}
      borderRadius={borderRadius}
      fontSize={fontSize}
      onClick={onClick ? onClick : null}
      disabled={disabled}
      boxShadow={boxShadow}
      width={width}
      paddingVertical={paddingVertical}
      paddingHorizontal={paddingHorizontal}
    >
      {LeftIcon ? (
        <LeftIcon color={btnColor ? btnColor : colors.white} size={"2rem"} />
      ) : null}
      <BtnText
        btnColor={btnColor}
        textTransform={textTransform}
        fontWeight={fontWeight}
        fontSize={fontSize}
        fontFamily={fontFamily}
        resfontSize={resfontSize}
      >
        {btnText}
      </BtnText>

      {RightIcon ? (
        <RightIcon
          color={btnColor ? btnColor : colors.white}
          size={iconSize ? iconSize : fontSizes.smallTitle}
        />
      ) : null}
    </ButtonStyles>
  );
};
